import { LoginPage } from './../../../login/login/login';
import { QRCodePage } from './../../../me/qrcode/qrcode';
import { SessionProvider } from './../../../../providers/session/session';
import { Component } from '@angular/core';
import { EventProvider } from '../../../../providers/event/event';
import { ModalController, NavController } from 'ionic-angular';

@Component({
  selector: 'page-event-tester',
  templateUrl: 'event-tester.html'
})
export class EventTester {
  constructor(
    private sessionService: SessionProvider,
    private eventService: EventProvider,
    private navController: NavController,
    private modalCtrl: ModalController
    ){ 
      this.navController.push(LoginPage);
    }
}




// WEBPACK FOOTER //
// /src/pages/event/main/event-tester/event-tester.ts